module.exports = __webpack_public_path__ + "img/bannerBg.e43e053c.png";